import { courseAxiosInstance as axios } from "../axios/axiosInstance"

export const uploadImageToCloud = async (formData) => {
    const config = {
        'Content-Type': 'application/json'
      }
    const { data } = await axios.post(`/private/courses/upload-image`, formData, config)
    return data
  }